<template>
  <div class="page__container">
    <navigation-bar :showNavigationItems="true" :showMyAccountIcon="true" />
    <div class="page__content-container">
      <h1 class="page__title">Nieuws</h1>
      <div class="news__items-container">
        <news-thumbnail v-for="newsItem in news" :key="newsItem._id" :newsItem="newsItem" :href="`/nieuws/${newsItem.slug}`"/>
      </div>
    </div>
    <footer-component />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/Footer.vue";

import { ref } from "vue";
import axios from "axios";
import date from "date-and-time";
import NewsThumbnail from '../components/NewsThumbnail.vue';

export default {
  components: { NavigationBar, FooterComponent, NewsThumbnail },
  setup() {
    const news = ref([]);

    const getNews = async () => {
      try {
        const { data } = await axios({
          url: "/api/news?limit=20",
          method: "GET",
          withCredentials: true,
        });

        news.value = data;
      } catch ({ response, message }) {
        console.log({ response, message });
      }
    };

    getNews();

    return {
      news,
      date,
    };
  },
};
</script>